import { Text, Heading, Divider, Box } from '@chakra-ui/react'
import type { Partner } from '@twlvxtwlv/types'
import Link from 'next/link'

interface PartnerProps {
  partner: Partner
}

export const PartnerCard = ({ partner }: PartnerProps) => {
  const { name, description, link } = partner
  return (
    <Box bgColor="txtBlue" mb={8}>
      <Divider borderColor="txtWhite" size="2" />
      <Box my={8} display="inline-block">
        <Link href={link} target="_blank" rel="noopener noreferrer">
          <Heading
            as="h3"
            size={{ base: 'md', lg: 'lg' }}
            color="txtWhite"
            _hover={{ color: 'txtDarkGray' }}
          >
            {name}
          </Heading>
        </Link>
      </Box>
      <Text fontFamily="heading" color="txtWhite">
        {description}
      </Text>
    </Box>
  )
}
